export default __webpack_public_path__ + "maps-examples-default-styles-thumbnail-960-9e6bad25b8870ce86da2e30b6b3ef106.webp";